<footer [ngClass]="{'desktop': !utilService.isMobile}" *ngIf="isStandalone">
  <mat-dialog-actions class="flex flex-start">
    <ng-container [ngTemplateOutlet]="footerContent"></ng-container>
  </mat-dialog-actions>
</footer>
<ng-container *ngIf="!isStandalone" [ngTemplateOutlet]="footerContent"></ng-container>
<ng-template #footerContent>
  <div class="flex flex-center" *ngIf="cartService.currentBooking?.number">
    <div class="heading-5 no-margin text-grey">
      <mat-icon class="svg-icon" [svgIcon]="'alert'"></mat-icon>
      {{'general.api_adding_tickets_to_booking_note' | translate}} {{cartService.currentBooking?.number}}
    </div>
    <a class="link" (click)="cartService.clearBooking()">
      <mat-icon class="svg-icon" [svgIcon]="'close'"></mat-icon>
      <span class="desktop">{{ 'general.api_general_cancel' | translate }}</span>
    </a>
  </div>
  <hr class="slim" *ngIf="!isStandalone && utilService.isMobile">
</ng-template>
